import { formatCifra, UNITS, type Unit } from '@alexiarest/shared';
import { activeLocale } from '../format';

/*
 * Cantidades para cocina (ficha técnica, recetario y vista de cocina). Va
 * aparte del generador del PDF para que la ventana y la vista de cocina no
 * arrastren pdf-lib.
 */

/** Hasta dos decimales, sin ceros de relleno y con las cifras del país («1,5» o «1.5»). */
const sinCeros = (n: number) => formatCifra(n, activeLocale(), 2);

/**
 * Cantidad para cocina: «30 g», «2 L», «167 g», «4 pz». Nunca «0,03 kg»,
 * «2.000 mL» ni «0,556 pz»; las piezas, siempre hacia arriba.
 */
export function cantidadCocina(qty: number, unit: Unit): string {
  const def = UNITS[unit];
  if (!def || !Number.isFinite(qty)) return `${sinCeros(qty)} ${unit === 'l' ? 'L' : unit}`;
  if (def.dimension === 'count') return `${Math.ceil(qty * def.factor - 1e-9)} pz`;
  if (unit === 'lb' || unit === 'oz' || unit === 'floz' || unit === 'gal' || unit === 'taza' || unit === 'cucharada' || unit === 'cucharadita') return `${sinCeros(qty)} ${def.label}`;
  const base = qty * def.factor;
  if (def.dimension === 'mass') return base >= 1000 ? `${sinCeros(base / 1000)} kg` : `${Math.max(1, Math.round(base))} g`;
  return base >= 1000 ? `${sinCeros(base / 1000)} L` : `${Math.max(1, Math.round(base))} mL`;
}

/**
 * «de los 2 kg que rinde»: la frase de la tanda, siempre exacta (revisión de
 * Alex, 12 oct 2026: «menos de un tercio» no cuadraba con 150 g de 2 kg).
 */
export function deLoQueRinde(yieldQty: number, yieldUnit: Unit): string {
  const tanda = cantidadCocina(yieldQty, yieldUnit);
  if (/^1 /.test(tanda)) return `de la tanda de ${tanda}`;
  const femenino = UNITS[yieldUnit]?.dimension === 'count' || yieldUnit === 'taza' || yieldUnit === 'cucharada' || yieldUnit === 'cucharadita';
  return `de ${femenino ? 'las' : 'los'} ${tanda} que rinde`;
}

/** Lo que hay que sacar o comprar antes de limpiar (la cantidad bruta). */
export function antesDeLimpiar(qty: number, wastePct: number): number {
  return wastePct > 0 && wastePct < 100 ? qty / (1 - wastePct / 100) : qty;
}
